<template>
  <header class="sub-gnb-rss flex flex-space-between flex-align-center">
    <button
      @click="routeBack(backUrl, false, partnersKey)"
      class="btn"
    >
      <nuxt-img
        class="ml-16"
        src="/icons/outline/chevron-left.svg"
        height="24"
        width="24"
        alt="back"
      />
    </button>
    <div
      v-if="title"
      class="title"
    >
      {{ title }}
    </div>
    <button
      @click="() => $emit('click-rss', true)"
      class="btn"
    >
      <nuxt-img
        v-if="visibleRss"
        id="gtm_share_btn"
        class="main-search-icon mr-16"
        src="/img/basic-icon/social-share.svg"
        type="button"
        alt="social"
      />
    </button>
  </header>
</template>

<script setup lang="ts">
const { routeBack } = useBack()

const props = withDefaults(
  defineProps<{
    partnersKey?: string
    visibleRss?: boolean
    title?: string
    backUrl?: string
  }>(),
  {
    partnersKey: '',
    visibleRss: true,
    title: '',
    backUrl: ''
  }
)

const emits = defineEmits(['click-rss'])
</script>
<style scoped lang="scss">
.title {
  @include body3-semibold;
}
.btn {
  background-color: transparent;
  border: none;
  padding: 0;
  display: flex;
  align-items: center;
}
</style>
